import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "swiper/css/bundle";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./components/ScrollRestoration";
import { store } from "./app/store";
import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";
import { Helmet } from "react-helmet";
import * as Sentry from "@sentry/react";
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from './lib/apollo';
import { captureAttribution } from './lib/attribution';

// First-touch signup attribution (task sheet Oct T2): remember UTM / ad click ids
// from the landing URL so Register can send them. Best effort, never throws.
try {
  captureAttribution(window.location.search, document.referrer, window.localStorage, new Date());
} catch {
  /* ignore */
}

Sentry.init({
  dsn: "https://5a6898479aaa2840b267fe8357720d80@o4506896481124352.ingest.us.sentry.io/4508907237670912",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 0.1, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    "localhost",
    "https://api.gcbuying.com", // added API endpoint
    "gcbuying.com", // added current URL
    /^https:\/\/yourserver\.io\/api/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  enabled: false
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <Provider store={store}>
    <ApolloProvider client={apolloClient}>
      <BrowserRouter>
        <ScrollToTop />
        <App />
        <Toaster toastOptions={{ className: "font-dashboard text-base" }} />
      </BrowserRouter>
      <Helmet>
        <script
          id="ze-snippet"
          src="https://static.zdassets.com/ekr/snippet.js?key=c1c7f506-75c2-41de-bc66-149ef6426955"
        >
          {" "}
        </script>
      </Helmet>
    </ApolloProvider>
  </Provider>
);
